import React from 'react'
import { readDraft } from './signupState'
import AcademySignupGuard from './AcademySignupGuard'

/**
 * Applies AcademySignupGuard only when the signup draft persona is academy
 * (shared /signup/account route).
 */
export default function AcademyAccountGuard({ children }) {
  const persona = readDraft()?.persona
  if (persona !== 'academy') return children
  return <AcademySignupGuard>{children}</AcademySignupGuard>
}
